import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const ChartContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1.2)}`};
  padding: ${() =>
    `${viewSizeCalculator(1.25)} ${viewSizeCalculator(1.2)}
       ${viewSizeCalculator(1.5)} ${viewSizeCalculator(1.2)}`}; // 0.625rem 1.25rem;

  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  background-color: #ffffff;
  box-shadow: ${() => `0 ${viewSizeCalculator(0.0625)} ${viewSizeCalculator(0.3125)} 0 solid #3333331a`};
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  font-family: Inter;
  font-weight: 700;
  font-size: ${() => `${viewSizeCalculator(1)}`};
  line-height: ${() => `${viewSizeCalculator(1.5)}`};
  letter-spacing: 0%;
`;

export const Subtitle = styled.p`
  font-family: Inter;
  font-weight: 400;
  font-size: ${() => `${viewSizeCalculator(0.913)}`};
  line-height: ${() => `${viewSizeCalculator(1.5)}`};
  letter-spacing: 0%;
`;
